import Account from '../../pages/Account'
import Prescription from '../../pages/Prescription'
import Referrals from '../../pages/Referrals'
import Consents from '../../pages/Consents'
import PastVisits from '../../pages/PastVisits'
import FutureVisits from '../../pages/FutureVisits'
import DoctorNotes from '../../pages/DoctorNotes'
import AuthenticatedRoute from './AuthenticatedRoute'
import Profile from '../../pages/Profile'
import ResetPassword from '../../pages/GetStarted/ResetPassword'
import PaymentDetails from '../../pages/PaymentDetails'
import ResetPasswordVerrifyCode from '../../pages/GetStarted/ResetPasswordVerifyCode'
import ChooseNewPassword from '../../pages/GetStarted/ResetAndChoosePassword'
import { FULL_APP_PERMISSION, clinicTypes, routes } from '../../../consts'
import PreCallCheck from '../../pages/PreCallCheck'
import ReferralResults from '../../pages/ReferralResults'
import BeforeVisitPage from '../../pages/BeforeVisitPage/BeforeVisitPage'
import GetCare from '../../pages/GetCare'
import Bot from '../../pages/Bot'
import MyPharmacy from '../../pages/MyPharmacy'
import EmergencyContact from '../../pages/EmergencyContact'
import PaymentPlans from '../../pages/PaymentPlans'
import HtnBotPreview from '../../pages/HtnBotPreview'
import MhBotPreview from '../../pages/MhBotPreview'
import DmBotPreview from '../../pages/DmBotPreview'
import MhBotInfo from '../../pages/MhBotInfo'
import SpecialityServices from '../../pages/SpecialityServices'
import MyActivity from '../../pages/MyActivity'
import GenderDetails from '../../pages/GenderDetails/GenderDetails'
import ContactInformation from '../../pages/ContactInformation/ContactInformation'
import SearchProviders from '../../pages/SearchProviders'
import SearchProvidersResults from '../../pages/SearchProviders/SearchProvidersResults'
import SecretQuestions from '../../pages/SecretQuestions'
import SettingsAndPreferences from '../../pages/SettingsAndPreferences'
import Language from '../../pages/Language/Language'
import CareTeam from '../../pages/CareTeam'
import {
  getIsHmoMember,
  isMemberTermed,
  isPastNhMember
} from '../../../utils/hmoUtils'
import Actions from '../../../actions'
import MobileWebUserBlocker from '../../pages/GetStarted/MobileWebUserBlocker'
import MvpStatus from '../../pages/MvpStatus'
import RiskAssessment from '../../pages/RiskAssessment'
import CommunicationPreferences from '../../pages/CommunicationPreferences'
import { Route } from 'react-router-dom'
import PaymentsAndBilling from '../../pages/PaymentsAndBilling'
import NHPage from '../../pages/NHPage'
import IdCards from '../../pages/IdCards'
import IdCardFileView from '../../pages/IdCards/IdCardFileView'
import Claims from '../../pages/Claims/Claims'
import SingleClaim from '../../pages/Claims/SingleClaim'
import InviteToApp from '../../pages/InviteToApp'
import { isMemberInsuranceNotActivated } from '../../../utils/hmoUtils'
import ManagePayments from '../../pages/ManagePayments'
import CoverageBenefitsByProvider from '../../pages/CoverageBenefitsByProvider'
import HmoHistoryData from 'components/pages/HmoHistoryData/HmoHistoryData'
import IframeView from '../../pages/IframeView'
import ProviderDetails from '../../pages/SearchProviders/ProviderDetails'

export const AppAuthRoutes = [
  {
    path: routes.IFRAME_VIEW,
    exact: true,
    component: IframeView,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.BEFORE_VISIT,
    exact: true,
    component: BeforeVisitPage,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.BOT,
    exact: true,
    component: Bot,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.RISK_ASSESSMENT_BOT,
    exact: true,
    component: RiskAssessment,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.TEST_CONNECTIVITY,
    component: PreCallCheck,
    route: AuthenticatedRoute
  },
  {
    path: routes.PAYMENT_PLANS,
    component: PaymentPlans,
    route: AuthenticatedRoute,
    exact: true,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.HTN_BOT_PREVIEW,
    component: HtnBotPreview,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.MH_BOT_PREVIEW,
    component: MhBotPreview,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.DM_BOT_PREVIEW,
    component: DmBotPreview,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.SEARCH_PROVIDERS,
    exact: true,
    component: SearchProviders,
    route: Route,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.SEARCH_PROVIDERS_RESULTS,
    exact: true,
    component: SearchProvidersResults,
    route: Route,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.PROVIDER_DETAILS,
    exact: true,
    component: ProviderDetails,
    route: Route,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.CLAIM,
    component: SingleClaim,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.MH_BOT_INFO,
    component: MhBotInfo,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.SPECIALITY_SERVICES,
    component: SpecialityServices,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.ACTIVITY,
    exact: true,
    component: MyActivity,
    route: Route,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.SECRET_QUESTIONS,
    exact: true,
    component: SecretQuestions,
    filter: userDetails => getIsHmoMember(userDetails),
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.NH_PAGE,
    exact: true,
    component: NHPage,
    filter: userDetails => getIsHmoMember(userDetails),
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.NH_PAGE_PUBLIC,
    exact: true,
    component: NHPage,
    route: Route,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.INVITE_TO_APP,
    exact: true,
    component: InviteToApp,
    filter: userDetails => getIsHmoMember(userDetails),
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.MANAGE_PAYMENTS,
    exact: true,
    component: ManagePayments,
    filter: userDetails => getIsHmoMember(userDetails),
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.MENU_ROUTE.HMO_HISOTRY_DATA,
    exact: true,
    component: HmoHistoryData,
    filter: userDetails => isPastNhMember(userDetails),
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  }
]

export const MenuRoutes = [
  {
    path: routes.ROOT,
    exact: true,
    name: 'sideMenu.home',
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.GET_CARE,
    exact: true,
    action: Actions.PRIMARY_CLINIC_CLICKED,
    name: 'sideMenu.seeAClinician',
    component: GetCare,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.SEARCH_PROVIDERS,
    exact: true,
    name: 'sideMenu.findAProvider',
    component: SearchProviders,
    filter: userDetails => getIsHmoMember(userDetails),
    route: Route,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    name: 'sideMenu.clinics.hypertension.hypertensionService',
    path: null,
    permissions: [FULL_APP_PERMISSION],
    filter: userDetails => !getIsHmoMember(userDetails),
    route: AuthenticatedRoute,
    children: [
      {
        name: clinicTypes.HTN,
        path: null,
        active: false
      }
    ]
  },
  {
    name: 'sideMenu.clinics.mentalHealth.mentalHealthService',
    path: null,
    permissions: [FULL_APP_PERMISSION],
    route: AuthenticatedRoute,
    children: [
      {
        name: clinicTypes.MENTAL,
        path: null,
        active: false
      }
    ]
  },
  {
    name: 'sideMenu.clinics.diabetes.diabetesService',
    path: null,
    permissions: [FULL_APP_PERMISSION],
    filter: userDetails => !getIsHmoMember(userDetails),
    route: AuthenticatedRoute,
    children: [
      {
        name: clinicTypes.DIABETES,
        path: null,
        active: false
      }
    ]
  },
  {
    path: routes.PROFILE_ROUTE.MVP_STATUS,
    name: 'sideMenu.mvpStatus',
    extra: true,
    component: MvpStatus,
    filter: userDetails => getIsHmoMember(userDetails),
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.MENU_ROUTE.MEDICAL_VISITS,
    name: 'sideMenu.appointments',
    children: [
      {
        path: routes.MENU_ROUTE.MECICAL_VISITS_FUTURE,
        name: 'sideMenu.futureVisits',
        component: FutureVisits,
        route: AuthenticatedRoute
      },
      {
        path: routes.MENU_ROUTE.MEDICAL_VISITS_PAST,
        name: 'sideMenu.pastVisits',
        component: PastVisits,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      }
    ]
  },
  {
    path: null,
    name: 'sideMenu.medicalRecords',
    permissions: [FULL_APP_PERMISSION],
    children: [
      {
        path: routes.MENU_ROUTE.PRESCRIPTION,
        name: 'sideMenu.prescriptions',
        component: Prescription,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.MENU_ROUTE.REFERRAL_RESULTS,
        name: 'sideMenu.myReferralResults',
        component: ReferralResults,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.MENU_ROUTE.REFERRALS,
        name: 'sideMenu.referrals',
        component: Referrals,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.MENU_ROUTE.DOCTOR_NOTES,
        name: 'sideMenu.doctorNotes',
        component: DoctorNotes,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      }
    ]
  },
  {
    path: null,
    name: 'sideMenu.profile',
    children: [
      {
        path: routes.PROFILE_ROUTE.PROFILE,
        name: 'sideMenu.manageProfile',
        exact: true,
        component: Profile,
        route: AuthenticatedRoute
      },
      {
        path: routes.PROFILE_ROUTE.ID_CARDS,
        name: 'sideMenu.idCards',
        component: IdCards,
        exact: true,
        route: AuthenticatedRoute,
        filter: userDetails => getIsHmoMember(userDetails),
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.PROFILE_ROUTE.COVERAGE,
        name: 'sideMenu.coverage',
        component: CoverageBenefitsByProvider,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION],
        filter: userDetails => getIsHmoMember(userDetails)
      },
      {
        path: routes.PROFILE_ROUTE.CARE_TEAM,
        name: 'sideMenu.careTeam',
        component: CareTeam,
        route: AuthenticatedRoute,
        filter: userDetails => getIsHmoMember(userDetails),
        permissions: [FULL_APP_PERMISSION]
      },
      {
        action: Actions.UPDATE_MY_PHARMACY_PRESSED,
        path: routes.PROFILE_ROUTE.PHARMACY,
        name: 'sideMenu.pharmacy',
        component: MyPharmacy,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.PROFILE_ROUTE.CONTACT_INFORMATION,
        name: 'sideMenu.contactInformation',
        component: ContactInformation,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.PROFILE_ROUTE.SETTING_PREFERENCES,
        name: 'sideMenu.settings',
        component: SettingsAndPreferences,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.PROFILE_ROUTE.EMERGENCY_CONTACT,
        name: 'sideMenu.emergencyContact',
        route: AuthenticatedRoute,
        component: EmergencyContact,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.PROFILE_ROUTE.MY_CONSENTS,
        name: 'sideMenu.consents',
        route: AuthenticatedRoute,
        component: Consents,
        permissions: [FULL_APP_PERMISSION]
      }
    ]
  },
  {
    name: 'sideMenu.hmoFinancialHistory',
    permissions: [FULL_APP_PERMISSION],
    filter: userDetails => isMemberTermed(userDetails),
    children: [
      {
        path: routes.MENU_ROUTE.PAYMENTS_HMO_HISTORY,
        name: 'sideMenu.payments',
        route: AuthenticatedRoute,
        component: PaymentsAndBilling,
        filter: userDetails => !!userDetails?.isOwner,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.MENU_ROUTE.CLAIMS_HMO_HISTORY,
        name: 'sideMenu.claims',
        route: AuthenticatedRoute,
        component: Claims,
        permissions: [FULL_APP_PERMISSION]
      },
      {
        path: routes.MENU_ROUTE.CONVERAGE_HMO_HISTORY,
        name: 'sideMenu.coverage',
        component: CoverageBenefitsByProvider,
        route: AuthenticatedRoute,
        permissions: [FULL_APP_PERMISSION]
      }
    ]
  },
  {
    path: routes.MENU_ROUTE.CLAIMS,
    name: 'sideMenu.claims',
    route: AuthenticatedRoute,
    component: Claims,
    disabled: userDetails => isMemberInsuranceNotActivated(userDetails),
    filter: userDetails => getIsHmoMember(userDetails),
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.MENU_ROUTE.PAYMENTS,
    name: 'sideMenu.payments',
    route: AuthenticatedRoute,
    component: PaymentsAndBilling,
    filter: userDetails =>
      getIsHmoMember(userDetails) && !!userDetails?.isOwner,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.MENU_ROUTE.ACCOUNT,
    component: Account,
    name: 'sideMenu.plans',
    route: AuthenticatedRoute,
    action: Actions.ACCOUNT_PRESSED,
    filter: userDetails => !getIsHmoMember(userDetails),
    permissions: [FULL_APP_PERMISSION]
  },
  {
    name: 'sideMenu.hmoHistoryData',
    path: routes.MENU_ROUTE.HMO_HISOTRY_DATA,
    component: HmoHistoryData,
    route: AuthenticatedRoute,
    filter: userDetails => isPastNhMember(userDetails),
    permissions: [FULL_APP_PERMISSION]
  },
  {
    name: 'sideMenu.debitCard',
    path: routes.MENU_ROUTE.DEBIT_CARD,
    route: AuthenticatedRoute,
    component: MobileWebUserBlocker,
    filter: userDetails => !getIsHmoMember(userDetails),
    permissions: [FULL_APP_PERMISSION]
  },
  {
    name: 'sideMenu.support',
    permissions: [FULL_APP_PERMISSION],
    children: [
      {
        name: 'sideMenu.faq',
        action: Actions.FAQ_CLICK,
        route: AuthenticatedRoute
      },
      {
        name: 'sideMenu.contactUs',
        action: Actions.SUPPORT_CLICK,
        route: AuthenticatedRoute
      }
    ]
  }
]

const ProfileRoutes = [
  {
    path: routes.PROFILE_ROUTE.PAYMENT_DETAILS,
    exact: true,
    component: PaymentDetails,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.PROFILE_ROUTE.RESET_PASSWORD,
    exact: true,
    component: ResetPassword,
    route: AuthenticatedRoute
  },
  {
    path: routes.PROFILE_ROUTE.PROFILE_RESET_PASSWORD_VERIFY_CODE,
    exact: true,
    component: ResetPasswordVerrifyCode,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.PROFILE_ROUTE.PROFILE_RESET_AND_CHOOSE_NEW_PASSWORD,
    exact: true,
    component: ChooseNewPassword,
    route: AuthenticatedRoute
  },
  {
    path: routes.PROFILE_ROUTE.GENDER_DETAILS,
    component: GenderDetails,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.PROFILE_ROUTE.CONTACT_INFORMATION,
    component: ContactInformation,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.PROFILE_ROUTE.COMMUNICATION_PREFERENCES,
    component: CommunicationPreferences,
    route: AuthenticatedRoute,
    filter: userDetails => getIsHmoMember(userDetails),
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.PROFILE_ROUTE.LANGUAGE,
    component: Language,
    route: AuthenticatedRoute,
    permissions: [FULL_APP_PERMISSION]
  },
  {
    path: routes.PROFILE_ROUTE.ID_CARD_FILE_VIEW,
    name: 'sideMenu.idCardFileView',
    component: IdCardFileView,
    route: AuthenticatedRoute,
    filter: userDetails => getIsHmoMember(userDetails),
    permissions: [FULL_APP_PERMISSION]
  }
]

export const AppRoutes = [...AppAuthRoutes, ...MenuRoutes, ...ProfileRoutes]
